module.exports = __webpack_public_path__ + "assets/images/e8fd0aa62ac1bba218e0101aea0e2f71.svg";